import { Connection } from '@solana/web3.js';

// Helius API key
const HELIUS_API_KEY = '679c9590-4e01-4683-9de9-e6dac0de94fc';

// Multiple RPC endpoints for fallback
// Primary endpoint is Helius, others are fallbacks
const RPC_ENDPOINTS = [
  // Primary Helius endpoint with API key
  `https://mainnet.helius-rpc.com/?api-key=${HELIUS_API_KEY}`,
  // Backup endpoints with CORS support
  'https://raydium.genesysgo.net',
  'https://solana-mainnet.rpc.extrnode.com',
  'https://api.mainnet-beta.solana.com'
];

// WebSocket URL (if needed)
export const WS_ENDPOINT = `wss://mainnet.helius-rpc.com/?api-key=${HELIUS_API_KEY}`;

// Create and return a new Solana connection with fallback support
export const createConnection = () => {
  // Use Helius endpoint by default
  return new Connection(RPC_ENDPOINTS[0], {
    commitment: 'confirmed',
    confirmTransactionInitialTimeout: 60000, // Timeout for transaction confirmation (in ms)
    wsEndpoint: WS_ENDPOINT // Include WebSocket for subscriptions
  });
};

// Get all available RPC endpoints for fallback
export const getSolanaRpcEndpoints = () => {
  return RPC_ENDPOINTS;
};

// SPL token addresses on Solana network
export const TOKEN_MINTS = {
  USDT: "Es9vMFrzaCERmJfrF4H2FYD4KCoNkY11McCe8BenwNYB", // USDT mainnet address
  USDC: "EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v", // USDC mainnet address
};

// SPL token decimals
export const TOKEN_DECIMALS = {
  USDT: 6, // USDT has 6 decimals
  USDC: 6, // USDC has 6 decimals
};

// Default recipient address for Quantum Genesis
export const QGEN_RECIPIENT = '7wFWCFfqbgyk5CYuV9nsNvY7p6aY2JCzUExbNML46pBv';
